import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const TableHead = ({ columnTitles }) => {
  return (
    <thead>
      <tr className="table-dark align-middle">
        {columnTitles.map((columnTitle, index) => (
          <th scope="col" key={index}>{columnTitle}</th>
        ))}
      </tr>
    </thead>
  );
};

function TableBody({ rows, renderRow, noRows = <></> }) {
  return (
    <tbody>
      {rows.length === 0 ? noRows : null}
      {rows.map(row => (
        renderRow(row)
      ))}
    </tbody>
  )
}

const Table = ({ id, columnTitles, rows, renderRow, noRowsText }) => {
  return (
    <table id={id} className="table table-striped table-hover table-bordered align-middle">
      <TableHead columnTitles={columnTitles} />
      <TableBody rows={rows} renderRow={renderRow} noRows={<DefaultNoRows noRowsText={noRowsText} columnCount={columnTitles.length} />} />
    </table>
  )
}


const DefaultNoRows = ({ noRowsText, columnCount }) => {
  return <td colSpan={columnCount}>
    <div role="alert" className="alert alert-info">
      <p className="small mb-0">{noRowsText}</p>
    </div>
  </td>
};

Table.propTypes = {
  columnTitles: PropTypes.arrayOf(PropTypes.string),
  rows: PropTypes.array,
  renderRow: PropTypes.func,
}

export default Table;
